import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=453d88dc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=453d88dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d88dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453d88dc')) {
      api.createRecord('453d88dc', component.options)
    } else {
      api.reload('453d88dc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=453d88dc&scoped=true&", function () {
      api.rerender('453d88dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kscws8Wm9NqN/JS/comp/DateRangeExt.vue"
export default component.exports